//import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

let modal;
let lastPos;
const cardAll = document.querySelectorAll(
	'.team-cards__card,' + '.block-team-slider__person'
);
const cache = JSON.parse(sessionStorage.getItem('teamCardsCache')) || {};
const tokens = {
	modalVisible: 'team-cards__modal--visible',
	modalLoading: 'team-cards__modal--loading',
};

/**
 * If the user clicks outside of the modal, close the modal
 *
 * @param {MouseEvent} e - the event object
 */
export const outsideClick = (e) => {
	if (e.target === modal) {
		history.pushState(
			'',
			document.title,
			window.location.pathname + window.location.search
		);
		closeModal();
	}
};
/**
 * It removes the `modalVisible` class from the modal element
 */
export const closeModal = () => {
	//enableBodyScroll(modal.querySelector('.team-cards__modal-wrapper'));
	window.scrollTo(0, lastPos);
	function removeHash() {
		history.pushState(
			'',
			document.title,
			window.location.pathname + window.location.search
		);
	}
	removeHash();
	modal.classList.remove(tokens.modalVisible);
};

/**
 * It disables scrolling on the body, and adds a class to the modal that makes it visible
 */
const openModal = () => {
	lastPos = window.scrollY;
	//disableBodyScroll(modal.querySelector('.team-cards__modal-wrapper'));
	modal.classList.add(tokens.modalVisible);
	modal.focus();
};

/**
 * It takes a string as an argument, and then it sets the innerHTML of the modal content.
 * It's not showing the modal, it's just setting the content.
 *
 * @param {string} content - The content to be displayed in the modal.
 */
const setModalContent = (content) => {
	modal.querySelector('.team-cards__modal-content').innerHTML =
		JSON.parse(content);
};

/**
 * Create a div that will be used as a modal.
 */
const createVirtualModal = () => {
	modal = document.createElement('div');
	modal.classList.add('team-cards__modal');
	modal.innerHTML = `
		<div class="team-cards__modal-wrapper">
			<a id="anchor-name" class="team-member__link-name"></a>
			<div class="team-cards__modal-close">
			</div>
			<div class="team-cards__modal-content">
			</div>
		</div>
	`;

	modal
		.querySelector('.team-cards__modal-close')
		.addEventListener('click', () => {
			closeModal();
		});

	document.body.appendChild(modal);
};

const bindEvents = () => {
	cardAll.forEach((cardNode) => {
		const id = cardNode.dataset.id;
		const href = `/wp-json/wp/v2/staff/${id}`;
		const urlHash = cardNode.dataset.urlHash;

		cardNode.addEventListener('mouseenter', () => {
			// Load the data in the background
			// Not supported with all browsers, but it's a nice to have
			const link = document.createElement('link');
			link.rel = 'prefetch';
			link.href = href;
			document.head.appendChild(link);
		});

		cardNode.addEventListener('click', (e) => {
			e.preventDefault();
			modal.classList.add(tokens.modalLoading);
			if (history.pushState) {
				history.pushState(null, null, urlHash);
			} else {
				location.hash = urlHash;
			}
			openModal();

			/* It's checking if the data is already in the cache. If it is, it's setting the content of the modal and
			instant removing the loading class. */
			if (cache[id]) {
				setModalContent(cache[id]);
				modal.classList.remove(tokens.modalLoading);
			} else {
				/* It's fetching the data from the API and then setting the content of the modal.
				Content is also saving in the session storage. */
				fetch(href)
					.then((response) => response.json())
					.then((data) => {
						cache[id] = data.template;
						setModalContent(data.template);
						modal.classList.remove(tokens.modalLoading);
					});
			}
		});
	});

	/* It's saving the cache to the session storage so that it can be used again when the user comes back to the page. */
	window.addEventListener('beforeunload', () => {
		sessionStorage.setItem('teamCardsCache', JSON.stringify(cache));
	});
};
const initialPageLoad = () => {
	cardAll.forEach((cardNode) => {
		const id = cardNode.dataset.id;
		const href = `/wp-json/wp/v2/staff/${id}`;
		const urlHash = cardNode.dataset.urlHash;

		if (urlHash === window.location.hash) {
			modal.classList.add(tokens.modalLoading);
			openModal();

			/* It's checking if the data is already in the cache. If it is, it's setting the content of the modal and
			instant removing the loading class. */
			if (cache[id]) {
				setModalContent(cache[id]);
				modal.classList.remove(tokens.modalLoading);
			} else {
				/* It's fetching the data from the API and then setting the content of the modal.
				Content is also saving in the session storage. */
				fetch(href)
					.then((response) => response.json())
					.then((data) => {
						cache[id] = data.template;
						// eslint-disable-next-line no-console
						console.log(data);
						setModalContent(data.template);
						modal.classList.remove(tokens.modalLoading);
					});
			}
		}
	});
};
function init() {
	if (cardAll) {
		bindEvents();
		createVirtualModal();
		initialPageLoad();
	}
}

export default init;
